import { Locale } from '@rbx/intl';
import { assistantGuidePathSuffix } from '../constants/assistantNavConstants';

const getAssistantGuideLinkForLocale = (locale: Locale) => {
  return `/${locale.toLowerCase()}${assistantGuidePathSuffix}`;
};

export default getAssistantGuideLinkForLocale;
